import { useEffect, useRef } from 'react'
import { State } from 'xstate'
import { flattenStateValue } from 'components/MultiStepFlow/utils/flattenStateValue'
import { HeapEventType, trackEventInHeap } from 'utils/heapTracking'
import { useABTestAssignment } from 'utils/abTesting'

/** Tracks every distinct state.id the machine enters (ignores utility states). */
export const useTrackRegistrationSteps = (state: State<any, any>) => {
  const prev = useRef<string | null>(null)
  const abTestAssignment = useABTestAssignment()

  useEffect(() => {
    const stepId = typeof state.value === 'string' ? state.value : flattenStateValue(state.value)

    if (['loading', 'redirect', 'done'].includes(stepId)) return
    if (prev.current === stepId) return

    trackEventInHeap(HeapEventType.NewRegistration, {
      action: stepId,
      ab_test_variant: abTestAssignment || undefined,
    })
    prev.current = stepId
  }, [state.value, abTestAssignment])
}
